/* eslint-disable */
import {
    ADDVENUE, GET_ALL_EXAM_CENTERS_LIST_FOR_DROPDOWN, GET_ALL_STATES_LIST_FOR_DROPDOWN, GET_ALL_DISTRICTS_LIST_FOR_DROPDOWN, ENTITY_MODIFY, GET_ALL_SUBDISTRICTS_LIST_FOR_DROPDOWN, GET_ALL_VILLAGES_LIST_FOR_DROPDOWN,
    GET_ALL_EXAM_MODES_LIST_FOR_DROPDOWN, GET_ALL_COORDINATOR_ROLES_LIST_FOR_DROPDOWN, GET_ALL_COORDINATOR_GENDERS_LIST_FOR_DROPDOWN, GET_ALL_UNAPPROVAL_ENTITY_LIST, ENTITY_APPROVAL, GET_ALL_APPROVED_ENTITY_LIST,
    UPLOAD_VENUE_CSV, GET_ALL_EXAM_CENTERS_LIST_BY_ADVT_ID, GET_ALL_VENUES_BY_EXAM_CENTER_ID, GET_VENUE_DETAILS_BY_VENUE_ID, ADD_ASSIGN_ADVT_TO_VENUE, GET_ALL_ACTIVE_VENUE_ADVT, UPDATE_VENUE_ADVT_DETAILS,
    UPDATE_VENUE_ADVT_ACTIVE_DELETE_LIST_ITEM, GET_EXAM_DISPLAY_NAME_BY_EXAM_ID, VENUE_SAMPLE_CSV_FILE_DOWNLOAD, VENUE_ADVT_ASSIGN_APPROVE_REJECT, GET_EXAM_SUBJECTS_LIST, GET_VENUE_ADVERTISEMENT_ASSIGNMENT, UPLOAD_VENUE_DISPLAY_ORDER,
    VENUE_DISPLAY_ORDER_SAMPLE_CSV_FILE_DOWNLOAD, SET_FORM_2_DATA, GET_FORM_2_DATA_STATUS, UPLOAD_FORM_2_CSV_FILE,
    GET_ALREADY_EXIST_FORM_2_CSV_DATA, SET_VENUE_ORDER
} from "../../common/constants/endpoints";
import API from "../../helpers/API";
import {
    SET_ALL_EXAM_CENTERS_LIST, SET_ALL_STATES_LIST, SET_ALL_DISTRICTS_LIST, SET_ALL_SUBDISTRICTS_LIST, SET_ALL_VILLAGES_LIST, SET_ALL_COORDINATOR_ROLES_LIST, SET_ALL_EXAM_MODES_LIST, SET_ALL_COORDINATOR_GENDERS_LIST, SET_VENUE_DETAILS_BY_VENUE_ID,
    SET_ALL_UNAPPROVAL_ENTITY_LIST, SET_ALL_APPROVED_ENTITY_LIST, SET_UPLOAD_CSV, GET_VENUE_ERRORLIST, SET_UNAPPROVAL_PAGE_NO_COUNTER, SET_APPROVED_PAGE_NO_COUNTER, SET_ALL_EXAM_CENTERS_LIST_BY_ADVT_ID, SET_ALL_VENUES_LIST_BY_EXAM_CENTER_ID,
    SET_ALL_ACTIVE_VENUE_ADVT, SET_ALL_ACTIVE_VENUE_ADVT_PAGE_NO_COUNTER, SET_EXAM_DISPLAY_NAME_BY_EXAM_ID, SET_EXAM_SUBJECTS_LIST, SET_FORM_2_DATA_STATUS
} from '../../common/constants/ActionTypes';
import { toastr } from 'react-redux-toastr';
import { getDocumentApprovalList } from "../../documentsverification/actions/documentVerificationAction";
import { hideLoader, showLoader } from "../../common/actions/commonActions";
import FileDownload from "js-file-download";
import dayjs from 'dayjs';

export const addVenue = (newVenueDetails, props) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADDVENUE, newVenueDetails, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getAllApprovalVenuesListPagination(0, 10));
            dispatch(getAllApprovedVenuesListPagination(0, 10));
            // dispatch(getAllVenue());
            props.setShowModal(false)

            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getAllApprovalVenuesListPagination = ( ) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_UNAPPROVAL_ENTITY_LIST + `/${pageNumber}` + `/${rowPerPage}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let allDone = false;
            if (response) {
                response && response.data && response.data.entityApprovalDtoList && response.data.entityApprovalDtoList.map((item, index) => {

                    let details = item.entityApprovalAction && item.entityApprovalAction.entityApprovalDto && item.entityApprovalAction.entityApprovalDto.detail && JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
                    let parentdetails = item.entityApprovalAction && item.entityApprovalAction.parentDetails && JSON.parse(item.entityApprovalAction.parentDetails);
                    response.data.entityApprovalDtoList[index].entityApprovalAction.entityApprovalDto.detail = details;
                    response.data.entityApprovalDtoList[index].entityApprovalAction.parentdetails = parentdetails;
                    if (index == response.data.entityApprovalDtoList.length - 1) {
                        allDone = true;
                    }
                    if (allDone) {
                        dispatch({
                            type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                            payload: response.data,
                        });
                        dispatch({
                            type: SET_UNAPPROVAL_PAGE_NO_COUNTER,
                            payload: (pageNumber * rowPerPage),
                        });

                    }
                })
            }

        } catch (error) {
            dispatch({
                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                payload: {},
            });
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getAllApprovedVenuesListPagination = (pageNumber, rowPerPage, searchText = '', examCenterid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let examcenterid = '';
        if (examCenterid) {
            examcenterid = examCenterid;
        }
        try {
            if ((searchText != '' && searchText != null && searchText != undefined) || (examcenterid != '' && examcenterid != null && examcenterid != undefined)) {

                response = await API.get(GET_ALL_APPROVED_ENTITY_LIST + `/search/${pageNumber}` + `/${rowPerPage}` + `?venuename=${searchText ? searchText : ""}` + `&examcenterid=${examcenterid}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else {
                response = await API.get(GET_ALL_APPROVED_ENTITY_LIST + `/${pageNumber}` + `/${rowPerPage}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            if (response) {

                dispatch({
                    type: SET_ALL_APPROVED_ENTITY_LIST,
                    payload: response.data,
                });
                dispatch({
                    type: SET_APPROVED_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });

            }

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            // toastr.error(errorMessage);
            dispatch({
                type: SET_ALL_APPROVED_ENTITY_LIST,
                payload: {},
            });
            return;
        }

    };
}

export const getAllExamCentersList = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_EXAM_CENTERS_LIST_FOR_DROPDOWN, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_EXAM_CENTERS_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const getAllStatesList = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            let countryId = 88;
            response = await API.get(GET_ALL_STATES_LIST_FOR_DROPDOWN + `/${countryId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_STATES_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getAllDistrictsList = (statecode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_DISTRICTS_LIST_FOR_DROPDOWN + `?statecode=${statecode}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_DISTRICTS_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getAllTalukasList = (districtcode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_SUBDISTRICTS_LIST_FOR_DROPDOWN + `/${districtcode}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_SUBDISTRICTS_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllVillagesList = (subdistrictcode) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let subdistcode = subdistrictcode ? subdistrictcode : "";
        try {
            response = await API.get(GET_ALL_VILLAGES_LIST_FOR_DROPDOWN + `?subdistcode=${subdistcode}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_VILLAGES_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllExamModesList = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_EXAM_MODES_LIST_FOR_DROPDOWN + `?type=mode`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_EXAM_MODES_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}
export const getAllCoordinatorRoles = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_COORDINATOR_ROLES_LIST_FOR_DROPDOWN + `?type=role`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_COORDINATOR_ROLES_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const getAllCoordinatorGenders = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_COORDINATOR_GENDERS_LIST_FOR_DROPDOWN + `?type=gender`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_COORDINATOR_GENDERS_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const approvalEntityRequest = (requestData, setShowModal) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ENTITY_APPROVAL, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setShowModal(false);
            dispatch(getAllApprovalVenuesListPagination(0, 10));
            dispatch(getAllApprovedVenuesListPagination(0, 10));

            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);

        } catch (error) {

            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);

            return;
        }
    }
}

export const experienceAndQualificationApproval = (requestData, level) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ENTITY_APPROVAL + `?isExpQual=true` + `&level=${level}`, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getDocumentApprovalList(requestData.applicationId));
            // dispatch(getAllApprovalVenuesListPagination(0, 10));
            // dispatch(getAllApprovedVenuesListPagination(0, 10));

            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);

        } catch (error) {

            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);

            return;
        }
    }
}

export const updateRequest = (requestData, setShowModal, listCurrentPage = 0, searchText = '') => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ADDVENUE, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setShowModal(false);
            dispatch(getAllApprovalVenuesListPagination(0, 10));
            dispatch(getAllApprovedVenuesListPagination(listCurrentPage, 10, searchText));
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const deleteVenueRequest = (requestData, setShowDeleteModal, searchText = '', rowPerPage, listCurrentPage) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ENTITY_MODIFY, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }
            setShowDeleteModal(false);
            dispatch(getAllApprovalVenuesListPagination(0, 10));
            dispatch(getAllApprovedVenuesListPagination(showPage, rowPerPage, searchText));
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const deleteVenueEntityRequest = (requestData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ENTITY_MODIFY, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getAllApprovalVenuesListPagination(0, 10));
            dispatch(getAllApprovedVenuesListPagination(0, 10));
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const modifyVenueRequest = (requestData, rowPerPage, listCurrentPage, searchText = '') => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ENTITY_MODIFY, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let showPage = 0;
            if (listCurrentPage > 0) {
                showPage = listCurrentPage;
            }
            dispatch(getAllApprovalVenuesListPagination(0, 10));
            dispatch(getAllApprovedVenuesListPagination(showPage, rowPerPage, searchText));
            let successMessage = (response && response.data) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const uploadVenueCsv = (data, setErrorList) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token
    let formData = new FormData();
    if (data.file) {
        formData.append('file', data.file);
    }
    if (data.action == "upload") {
        formData.append('showOnlySummary', true);
    }
    if (data.action == "save") {
        formData.append('showOnlySummary', false);
    }
    let response;
    let header = {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "type": "formData",
    }


    return async (dispatch) => {
        try {
            response = await API.post(UPLOAD_VENUE_CSV, formData, {
                headers: header
            });


            if (response.data) {
                dispatch({
                    type: SET_UPLOAD_CSV,
                    payload: response.data
                })
                if (response?.data?.venueCsvDtoList.length > 0) {


                    dispatch({
                        type: GET_VENUE_ERRORLIST,
                        payload: response?.data?.venueCsvDtoList
                    })


                    toastr.error("Please check the errors in downloaded file. Provide all relevent information and try again.");
                    if (data.action == "save") {
                        dispatch(resetVenueErrorList());
                    }
                }



                if (data.action == "upload") {
                    toastr.success("Correct Data Uploaded Successfully");
                }
                if (data.action == "save") {
                    toastr.success("Correct Data Saved Successfully");
                    dispatch(resetVenueErrorList());
                }
            }

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};
export const resetVenueErrorList = () => {
    return async (dispatch) => {
        dispatch({
            type: GET_VENUE_ERRORLIST,
            payload: []
        })
    }
}

export const getAllExamCenterListByAdvtId = (advtId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_EXAM_CENTERS_LIST_BY_ADVT_ID + `${advtId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_EXAM_CENTERS_LIST_BY_ADVT_ID,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const getAllVenuesListByExamCenterId = (examcenterId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_VENUES_BY_EXAM_CENTER_ID + `${examcenterId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_ALL_VENUES_LIST_BY_EXAM_CENTER_ID,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const getVenueDetailsByVenueId = (venueId, advertisementId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_VENUE_DETAILS_BY_VENUE_ID + `${venueId}` + `/${advertisementId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_VENUE_DETAILS_BY_VENUE_ID,
                payload: response.data,
            });
            let venueAdvertisementAssignmentObj = {};
            venueAdvertisementAssignmentObj.venueAdvertisementAssignmentResponse = {};
            venueAdvertisementAssignmentObj.venueAdvertisementAssignmentResponse.venueDetails = response.data;
            dispatch({
                type: SET_ALL_ACTIVE_VENUE_ADVT,
                payload: venueAdvertisementAssignmentObj,
            });
            if (response && response.data && response.data.subdistrictcode) {
                dispatch(getAllTalukasList(response.data.districtcode));
            };
            if (response && response.data && response.data.villagecode) {
                dispatch(getAllVillagesList(response.data.subdistrictcode));
            };

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
        // dispatch(getAllActiveVenueAdvtList(0,10));
    };
};

export const addAssignAdvtToVenue = (reqData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_ASSIGN_ADVT_TO_VENUE, reqData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = (response && response.data) ? response.data : response.message
            toastr.success(successMessage);
            // window.location.reload();
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getAllActiveVenueAdvtList = (pageNumber, rowPerPage, advtid, examsubjectId, examDate, examCenterId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let pageno = pageNumber ? pageNumber : "";
        let size = rowPerPage ? rowPerPage : "";
        let advid = advtid ? advtid : "";
        let examsubjectid = examsubjectId ? examsubjectId : "";
        let examdate = examDate ? dayjs(examDate).format('DD-MM-YYYY') : "";
        let examCenterid = examCenterId ? examCenterId : "";

        try {
            response = await API.get(GET_VENUE_ADVERTISEMENT_ASSIGNMENT + `?pageno=${pageno}` + `&size=${size}` + `&advid=${advid}` + `&examsubjectid=${examsubjectid}` + `&examdate=${examdate}` + `&examcenterid=${examCenterid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let allDone = false;
            if (response) {
                response && response.data && response.data.venueAdvertisementAssignmentResponseList && response.data.venueAdvertisementAssignmentResponseList.map((item, index) => {
                    let details = item.venueDetails && JSON.parse(item.venueDetails);
                    response.data.venueAdvertisementAssignmentResponseList[index].venueDetails = details;
                    if (index == response.data.venueAdvertisementAssignmentResponseList.length - 1) {
                        allDone = true;
                    }
                    if (allDone) {
                        dispatch({
                            type: SET_ALL_ACTIVE_VENUE_ADVT,
                            payload: response.data,
                        });
                        dispatch({
                            type: SET_ALL_ACTIVE_VENUE_ADVT_PAGE_NO_COUNTER,
                            payload: (pageNumber * rowPerPage),
                        });
                    }
                })
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            // toastr.error(errorMessage);
            dispatch({
                type: SET_ALL_ACTIVE_VENUE_ADVT,
                payload: {},
            });
            return;
        }

    };
}

export const getAllActiveVenueAdvtListById = (id) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_ACTIVE_VENUE_ADVT + `?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let allDone = false;
            if (response) {
                let item = response && response.data && response.data.venueAdvertisementAssignmentResponse;
                let details = item.venueDetails && JSON.parse(item.venueDetails);
                response.data.venueAdvertisementAssignmentResponse.venueDetails = details;
                dispatch({
                    type: SET_ALL_ACTIVE_VENUE_ADVT,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const updateVenueAdvtDetailsRequest = (requestData) => {
    return async (dispatch) => {
        dispatch(showLoader());
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(UPDATE_VENUE_ADVT_DETAILS, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = (response && response.data) ? response.data : response.message;
            toastr.success(successMessage);
            if (response) {
                // window.location.reload();
            }
            if (response != null) {
                dispatch(hideLoader());
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const updateVenueAdvtActiveDeleteListItem = (requestData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(UPDATE_VENUE_ADVT_ACTIVE_DELETE_LIST_ITEM, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = (response && response.data && response.data.message) ? response.data.message : response.message
            toastr.success(successMessage);
            // window.location.reload()
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const getExamDisplayNameByExamId = (examid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_EXAM_DISPLAY_NAME_BY_EXAM_ID + `?examid=${examid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_EXAM_DISPLAY_NAME_BY_EXAM_ID,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const venueSampleCsvFileDownload = () => {
    return async () => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(VENUE_SAMPLE_CSV_FILE_DOWNLOAD,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                    responseType: 'blob',
                }
            );
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                JSON.parse(await error.response.data.text()).message : error.message
            toastr.error(errorMessage);
            return;
        }
        FileDownload(response.data, `Venue Sample File.csv`);
    }
};

export const venueAdvtAssignApproveRejectAPI = (reqData, advtid) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(VENUE_ADVT_ASSIGN_APPROVE_REJECT, reqData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.data) {
                dispatch(getAllActiveVenueAdvtList(0, 10, advtid));
                // window.location.reload();
            }
            let successMessage = (response && response.data && response.data.message) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getExamSubjectList = (advId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let advid = advId ? advId : '';
        try {
            response = await API.get(GET_EXAM_SUBJECTS_LIST + `?advid=${advid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response) {
                dispatch({
                    type: SET_EXAM_SUBJECTS_LIST,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const venueDisplayOrderSampleCsvFileDownload = (advid, examcenterid, AdvtNoAndYear, subjectcode, examdate) => {
    return async () => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(VENUE_DISPLAY_ORDER_SAMPLE_CSV_FILE_DOWNLOAD + `?advid=${advid}` + `&examcenterid=${examcenterid}` + `&subjectcode=${subjectcode}` + `&examdate=${examdate}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                    responseType: 'blob',
                }
            );
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                JSON.parse(await error.response.data.text()).message : error.message
            toastr.error(errorMessage);
            return;
        }
        FileDownload(response.data, `Venue Display Order File_${AdvtNoAndYear}.csv`);
    }
};

export const uploadVenueDisplayOrderCsv = (data) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token
    let formData = new FormData();
    if (data.file) {
        formData.append('file', data.file);
    }
    if (data.advid) {
        formData.append('advid', data.advid);
    }
    if (data.examcenterid) {
        formData.append('examcenterid', data.examcenterid);
    }
    if (data.action == "upload") {
        formData.append('showOnlySummary', true);
    }
    if (data.action == "save") {
        formData.append('showOnlySummary', false);
    }
    let response;
    let header = {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "type": "formData",
    }
    return async (dispatch) => {
        try {
            response = await API.post(UPLOAD_VENUE_DISPLAY_ORDER, formData, {
                headers: header
            });
            if(response && response.data){
                let successMessage = (response && response.data && response.data.message) ? response.data.message : response.message
                toastr.success(successMessage);
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const downloadForm2API = (advid, examsubjectid, examdate, examcenterid, reqData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let examDate = examdate ? dayjs(examdate).format('DD/MM/YYYY') : "";
        try {
            response = await API.post(SET_FORM_2_DATA + `?advid=${advid}` + `&examsubjectid=${examsubjectid}` + `&examdate=${examDate}` + `&examcenterid=${examcenterid}`, reqData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if ((response) && (response.data) && (response.data === "No records found")) {
                toastr.error("No records found")
            }else if (response && response.data) {
                FileDownload(response.data, `Form_2.csv`);
                toastr.success("Data Download Successfully")
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getForm2DataStatusAPI = (advid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_FORM_2_DATA_STATUS + `?advid=${advid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response) {
                dispatch({
                    type: SET_FORM_2_DATA_STATUS,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const uploadForm2DataAPI = (data) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token
    let formData = new FormData();
    if (data.file) {
        formData.append('file', data.file);
    }
    let advid = data.advid ? data.advid : "";
    let examsubjectid = data.examsubjectid ? data.examsubjectid : "";
    let examdate = data.examdate ? dayjs(data.examdate).format('DD/MM/YYYY') : "";
    let examcenterid = data.examcenterid ? data.examcenterid : "";

    if (data.action == "upload") {
        formData.append('showOnlySummary', true);
    }
    if (data.action == "save") {
        formData.append('showOnlySummary', false);
    }
    let response;
    let header = {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "type": "formData",
    }
    return async (dispatch) => {
        try {
            response = await API.post(UPLOAD_FORM_2_CSV_FILE + `?advid=${advid}` + `&examsubjectid=${examsubjectid}` + `&examdate=${examdate}` + `&examcenterid=${examcenterid}`, formData, {
                headers: header
            });
            let successMessage = (response && response.data && response.data.message) ? response.data.message : response.message
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getAlreadyExistsForm2CsvDataAPI = (advid, examsubjectid, examdate, examcenterid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let examDate = examdate ? dayjs(examdate).format('DD/MM/YYYY') : "";
        try {
            response = await API.get(GET_ALREADY_EXIST_FORM_2_CSV_DATA + `?advid=${advid}` + `&examsubjectid=${examsubjectid}` + `&examdate=${examDate}` + `&examcenterid=${examcenterid}` , {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response && response.data) {
                FileDownload(response.data, `Form_2.csv`);
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
}

export const updateDownloadedForm2API = (advid, examsubjectid, examdate, examcenterid, reqData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let examDate = examdate ? dayjs(examdate).format('DD/MM/YYYY') : "";
        try {
            response = await API.patch(SET_FORM_2_DATA + `?advid=${advid}` + `&examsubjectid=${examsubjectid}` + `&examdate=${examDate}` + `&examcenterid=${examcenterid}`, reqData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if ((response) && (response.data) && (response.data === "No records found")) {
                toastr.error("No records found")
            }else if (response && response.data) {
                FileDownload(response.data, `Form_2.csv`);
                toastr.success("Data Download Successfully")
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const setVenueOrderAPI = (advtid, examcenterId, reqData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let advid = advtid ? advtid : '';
        let examcenterid = examcenterId ? examcenterId : '';
        try {
            response = await API.post(SET_VENUE_ORDER + `?advid=${advid}` + `&examcenterid=${examcenterid}`, reqData, {
                headers: { Authorization: `Bearer ${token}` },
            });
           
            if(response && response.data){
                dispatch(getAllActiveVenueAdvtList(0, 10, advtid));
                let successMessage = (response && response.data && response.data.message) ? response.data.message : response.message
                toastr.success(successMessage);
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};